import { format } from 'date-fns'
import { enUS, id } from 'date-fns/locale'

const locales = {
  en: enUS, 
  id: id
}

localStorage.getItem('i18nextLng')

// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
const formatDate = (date, formatStr = 'PP') => {
  return format(date, formatStr, {
    locale: locales[localStorage.getItem('i18nextLng')]
  })
}

export default formatDate;